import { Stack } from '../Stack';
import React from 'react';
import { Label } from '../Label';
import { FieldErrorMessage } from '../Validation/FieldErrorMessage';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FormField = props => {
  return /*#__PURE__*/_jsxs(Stack, {
    styles: props.styles,
    children: [!props.labelHidden && /*#__PURE__*/_jsx(Stack, {
      horizontal: true,
      horizontalAlign: "space-between",
      grow: true,
      children: /*#__PURE__*/_jsx(Stack.Item, {
        align: "start",
        children: /*#__PURE__*/_jsxs(Label, {
          children: [props.label, props.required && /*#__PURE__*/_jsx("span", {
            style: {
              color: 'rgb(164, 38, 44)'
            },
            children: "*"
          })]
        })
      })
    }), props.children, props.errorMessages && props.errorMessages.map((error, index) => error && /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: error
    }, "error".concat(index)))]
  });
};